(() => {
  const RUNTIME_NAME = 'MarineMaxTechnicalSpecificationsVideo';
  const VIDEO_SELECTOR = '.product-technical-specs__video';
  const FRAME_SELECTOR = `${VIDEO_SELECTOR}[data-src]`;
  const OBSERVER_OPTIONS = Object.freeze({ rootMargin: '200px 0px' });

  const existingRuntime = window[RUNTIME_NAME];
  if (existingRuntime?.initialize) {
    existingRuntime.initialize();
    return;
  }

  const observedFrames = new WeakSet();
  let observer = null;

  const collectFrames = (root) => {
    if (!root) return [];

    const frames = [];
    if (typeof root.matches === 'function' && root.matches(FRAME_SELECTOR)) frames.push(root);
    if (typeof root.querySelectorAll === 'function') {
      frames.push(...root.querySelectorAll(FRAME_SELECTOR));
    }

    return [...new Set(frames)];
  };

  const loadFrame = (frame) => {
    const source = frame?.dataset?.src;
    if (!source) return false;

    frame.src = source;
    frame.removeAttribute('data-src');
    observedFrames.delete(frame);
    return true;
  };

  const getObserver = () => {
    if (observer || typeof window.IntersectionObserver !== 'function') return observer;

    observer = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || !observedFrames.has(entry.target)) return;

        observer.unobserve(entry.target);
        observedFrames.delete(entry.target);
        loadFrame(entry.target);
      });
    }, OBSERVER_OPTIONS);

    return observer;
  };

  const initialize = (root = document) => {
    const frames = collectFrames(root);
    if (!frames.length) return 0;

    const activeObserver = getObserver();
    if (!activeObserver) {
      return frames.reduce((loadedCount, frame) => loadedCount + Number(loadFrame(frame)), 0);
    }

    let observedCount = 0;
    frames.forEach((frame) => {
      if (observedFrames.has(frame)) return;
      observedFrames.add(frame);
      activeObserver.observe(frame);
      observedCount += 1;
    });

    return observedCount;
  };

  const destroy = (root) => {
    if (!root || !observer) return;

    const videos = [];
    if (typeof root.matches === 'function' && root.matches(VIDEO_SELECTOR)) videos.push(root);
    if (typeof root.querySelectorAll === 'function') {
      videos.push(...root.querySelectorAll(VIDEO_SELECTOR));
    }

    [...new Set(videos)].forEach((frame) => {
      if (!observedFrames.has(frame)) return;
      observer.unobserve(frame);
      observedFrames.delete(frame);
    });
  };

  window[RUNTIME_NAME] = { destroy, initialize };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
